/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipMetadataAdvertisersQueryResponse, AuditReportsGetGipMetadataAdvertisersQueryParams, AuditReportsGetGipMetadataAdvertisers401, AuditReportsGetGipMetadataAdvertisers403 } from "../models/AuditReportsGetGipMetadataAdvertisers";

export function getAuditReportsGetGipMetadataAdvertisersUrl() {
  const res = { method: 'GET', url: `/audit-reports/v1/reports/gip/metadata/advertisers` as const }
  return res
}

/**
 * @summary Return cached GIP advertisers for the client
 * {@link /audit-reports/v1/reports/gip/metadata/advertisers}
 */
export async function auditReportsGetGipMetadataAdvertisers(params?: AuditReportsGetGipMetadataAdvertisersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetGipMetadataAdvertisersQueryResponse, ResponseErrorConfig<AuditReportsGetGipMetadataAdvertisers401 | AuditReportsGetGipMetadataAdvertisers403>, unknown>({ method : "GET", url : getAuditReportsGetGipMetadataAdvertisersUrl().url.toString(), params, ... requestConfig })
  return res.data
}